import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp } from '@fortawesome/pro-light-svg-icons';

export function ThumbsUpIcon({ color = '' }) {
  const styleObj: React.CSSProperties = color ? { color } : {};
  return <FontAwesomeIcon style={styleObj} icon={faThumbsUp} size="xs" />;
}
